/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

interface Props {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

export const InsightsPagination: React.FC<Props> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div className='text-md text-ThemeTextMedium me-3'>
        Showing {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} insights
      </div>
      <Pagination className='mb-0' listClassName='mb-0'>
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink previous onClick={() => onPageChange(currentPage - 1)}><i className='fal fa-chevron-left' /></PaginationLink>
        </PaginationItem>
        {[...Array(totalPages)].map((_, i) => {
          const page = i + 1;
          if (
            page === 1 ||
            page === totalPages ||
            (page >= currentPage - 1 && page <= currentPage + 1)
          ) {
            return (
              <PaginationItem key={page} active={page === currentPage}>
                <PaginationLink onClick={() => onPageChange(page)}>{page}</PaginationLink>
              </PaginationItem>
            );
          } else if (page === currentPage - 2 || page === currentPage + 2) {
            return (
              <PaginationItem key={page} disabled>
                <PaginationLink>...</PaginationLink>
              </PaginationItem>
            );
          }
          return null;
        })}
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink next onClick={() => onPageChange(currentPage + 1)}><i className='fal fa-chevron-right' /></PaginationLink>
        </PaginationItem>
      </Pagination>
    </div>
  );
};
